<template>
  <div>
    <h2>アクセス</h2>
    <kcs-map
      :lat="detail.lat"
      :lng="detail.lng"
      :zoom="zoom"
      :place-name="detail.name"
      :address="address"
      :place-id="detail.place_id"
    />
    <kcs-facility-info-list :detail="detail" />
    <kcs-facility-streetview :detail="detail" />
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
import KcsMap from '@/components/atoms/kcs-map.vue'
import KcsFacilityInfoList from '@/components/molecules/kcs-facility-info-list.vue'
import KcsFacilityStreetview from '@/components/molecules/kcs-facility-streetview.vue'
export default {
  components: {
    KcsMap,
    KcsFacilityInfoList,
    KcsFacilityStreetview
  },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    address() {
      return methods.getFacilityAddress(this.detail)
    },
    zoom() {
      return process.env.MAP_ZOOM
    }
  }
}
</script>
